/* eslint-disable camelcase */
import React from 'react';
import { orderBy } from 'lodash';
import { compare, rcompare } from 'semver';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import ErrorTwoToneIcon from '@mui/icons-material/ErrorTwoTone';
import { type TableState } from '../components/table';
import { type ColumnDataProps } from '../components/props/tables';
import generateColorAndText from './generate-color-and-text';

export type Device = {
  model: string;
  platform: string;
  email: string;
  fulcrum_version: string;
  last_synced_at: string;
};

export type Org = {
  name: string;
  plan: string;
};

export const localColumnSorter = (data: Device[], sort: TableState['sort'], sortDirection: TableState['sortDirection']) => {
  if (sort === 'last_synced_at') {
    return orderBy(data, (dateColumn) => new Date(dateColumn[sort]), sortDirection);
  }

  if (sort === 'fulcrum_version') {
    return sortDirection === 'desc'
      ? data.sort((curr, next) => rcompare(curr[sort], next[sort]))
      : data.sort((curr, next) => compare(curr[sort], next[sort]));
  }

  return orderBy(data, sort, sortDirection);
};

const renderTooltipCell = ({ platform, fulcrum_version }) => {
  const { color, text } = generateColorAndText({ platform, fulcrum_version });

  return (
    <Stack sx={{ color }} direction="row" alignItems="center">
      {fulcrum_version}
      {!!text.length && (
        <Tooltip sx={{ ml: 0.5 }} title={text} arrow placement="top">
          <ErrorTwoToneIcon />
        </Tooltip>
      )}
    </Stack>
  );
};

const columns: ColumnDataProps[] = [
  {
    width: 80,
    label: 'Current User',
    dataKey: 'email',
  },
  {
    width: 80,
    label: 'Device (Model)',
    dataKey: 'model',
  },
  {
    width: 80,
    label: 'Fulcrum version',
    dataKey: 'fulcrum_version',
    render: renderTooltipCell,
  },
  {
    width: 80,
    label: 'Last Synced',
    dataKey: 'last_synced_at',
    date: true,
  },
];

export default columns;
